// extracted by mini-css-extract-plugin
export default {"main":"v3-z"};